<template>
    <div class="box">
        <!-- <div v-if="!showAdd"> -->
        <div class="headline mb8" ref="getheight">员工管理</div>
        <div class="headline_div mb16" ref="getheight1">
            <span class="u_text">员工仅可查看数据明细里对应省市权限的数据</span>
            <el-button class="input_button" size="mini" @click="getAdd('add')">新增</el-button>
        </div>

        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column label="序号" width="100" :render-header="renderPrice">
                <template slot-scope="scope">
                    <span>{{ (scope.$index += 1) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="员工姓名" width="150" :render-header="renderPrice"> </el-table-column>
            <el-table-column prop="email" label="账号" width="180" :render-header="renderPrice"> </el-table-column>
            <el-table-column label=" 权限" min-width="200" :render-header="renderPrice">
                <template slot-scope="scope">
                    <span class="item textJustify">{{ scope.row.area.join('，') }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250" fixed="right">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="getReset(scope)">重置密码</el-button>
                    <el-button type="primary" size="mini" @click="getAdd('edit', scope)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="getDel(scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
        <el-dialog title="重置密码" :visible.sync="resetDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-form :model="rowRemark">
                <el-form-item>
                    <el-input v-model="rowRemark.password" size="mini" clearable placeholder="输入新密码"></el-input>
                </el-form-item>
            </el-form>

            <!-- show-password -->
            <div class="dialog-footer">
                <!-- <el-button size="mini" @click="resetDialogFalse">取 消</el-button> -->
                <div class="v_buttons" @click="resetDialogTrue">确 定</div>
            </div>
        </el-dialog>
        <!-- </div> -->
        <el-dialog :title="row.id ? '编辑员工' : '新增员工'" :visible.sync="showAdd" width="648px" top="15vh" class="v_doing">
            <div class="span mb24">员工仅可查看数据明细里对应省市权限的数据</div>
            <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="员工名称">
                    <el-input class="el_input" size="mini" clearable v-model="ruleForm.name" placeholder="请输入员工名称"></el-input>
                </el-form-item>
                <el-form-item label="员工账号">
                    <el-input
                        class="el_input"
                        size="mini"
                        clearable
                        v-model="ruleForm.email"
                        placeholder="请输入邮箱(用于接收下载数据)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="初始密码" v-if="row.id">
                    <el-input disabled show-password size="mini" v-model="password" placeholder="请输入初始密码"></el-input>
                </el-form-item>
                <el-form-item label="初始密码" v-else>
                    <el-input size="mini" v-model="ruleForm.password" placeholder="请输入初始密码" clearable></el-input>
                </el-form-item>
                <div class="areaArr">
                    <el-form-item label="查询/审核区域" >
                        <div v-for="(item, index) of areaArr" :key="index">
                            <div class="flexCenter" :class="index == areaArr.length - 1 ? '' : 'mb8'">
                                <el-select
                                    v-model="item.province_id"
                                    placeholder="请选择省"
                                    @change="getpID(index)"
                                    size="mini"
                                    class="mr10"
                                    clearable
                                >
                                    <el-option v-for="item in area" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                                </el-select>
                                <el-select v-model="item.city_id" placeholder="请选择市" size="mini" class="mr10" clearable>
                                    <el-option v-for="item of areaArr[index].cityArr" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                                <div class="flexCenter">
                                    <img class="v_add mr5" src="../../assets/img/add.png" alt="" @click="getIncrease()" />
                                    <img class="v_add v_min" src="../../assets/img/min.png" alt="" @click="getDelete(index)" />
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item>
                    <div class="dialog-footer">
                        <!-- <el-button size="mini" type="primary" @click="submitForm('ruleForm')">保存</el-button>
                    <el-button size="mini" @click="resetForm('ruleForm')">取消</el-button> -->
                        <div class="v_buttons" @click="submitForm('ruleForm')">确 定</div>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- <div v-else>
            <div class="mt15"></div>
            <el-page-header @back="goBack" :content="row.id ? '编辑员工' : '新增员工'" />
            <div class="mt15"></div>
            <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="员工名称" prop="name">
                    <el-input class="el_input" size="mini" clearable v-model="ruleForm.name" placeholder="请输入员工名称"></el-input>
                </el-form-item>
                <el-form-item label="员工账号" prop="email">
                    <el-input
                        class="el_input"
                        size="mini"
                        clearable
                        v-model="ruleForm.email"
                        placeholder="请输入邮箱(用于接收下载数据)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="初始密码" :prop="row.id ? '' : password">
                    <el-input
                        v-if="row.id"
                        :disabled="row.id ? true : false"
                        show-password
                        class="el_input"
                        size="mini"
                        v-model="password"
                        placeholder="请输入初始密码"
                    ></el-input>
                    <el-input
                        v-else
                        show-password
                        class="el_input"
                        size="mini"
                        v-model="ruleForm.password"
                        placeholder="请输入初始密码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="查询/审核区域">
                    <div v-for="(item, index) of areaArr" :key="index">
                        <el-select
                            v-model="item.province_id"
                            placeholder="请选择省"
                            @change="getpID(index)"
                            size="mini"
                            class="mr10"
                            clearable
                        >
                            <el-option v-for="item in area" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                        <el-select v-model="item.city_id" placeholder="请选择市" size="mini" class="mr10" clearable>
                            <el-option v-for="item of areaArr[index].cityArr" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                        <i class="el-icon-circle-plus-outline size" @click="getIncrease()"></i>
                        <i class="el-icon-remove-outline size" @click="getDelete(index)"></i>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="submitForm('ruleForm')">保存</el-button>
                    <el-button size="mini" @click="resetForm('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div> -->
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title">{{ msg }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'staff',
    data() {
        return {
            showAdd: false,
            page: {
                num: 10,
                page: 1,
                total: 0
            },
            message: [],
            ruleForm: {
                name: '',
                email: '',
                password: ''
            },
            rules: {
                name: [{ required: true, message: '请输入员工名称', trigger: 'blur' }],
                email: [{ required: true, message: '请输入邮箱(用于接收下载数据)', trigger: 'blur' }],
                password: [{ required: true, message: '请输入初始密码', trigger: 'blur' }]
            },
            area: [],
            province_id: '',
            cityArr: [],
            city_id: '',
            areaArr: [],
            password: '123456798',
            rowRemark: {
                password: ''
            },
            index: -1,
            height: '',
            msg:'',
            notificationns:false,
            row: {}, //点击编辑的数据
            resetDialogVisible: false //重置密码
        };
    },

    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 40;
        let area = localStorage.getItem('area');
        this.area = JSON.parse(area);
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num
            };
            that.$get('/backapi/user', obj).then(function (res) {
   
                if (res.count) {
                    that.page.total = res.count;
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].area = [];
                        for (let j = 0; j < res.data[i].area_info.length; j++) {
                            res.data[i].area.push(res.data[i].area_info[j].province_name + res.data[i].area_info[j].city_name);
                        }
                    }
                    that.message = res.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 获取省id
        getpID(index) {
            let that = this;

            that.$get('/backapi/area', { province_id: that.areaArr[index].province_id }).then(function (res1) {
                that.areaArr[index].city_id = '';
                that.areaArr[index].cityArr = res1.data;
            });
        },
        //添加 编辑
        getAdd(type, e) {
            this.areaArr = [{ province_id: '', city_id: '', country_id: 227, cityArr: [] }];
            if (type == 'add') {
                this.resFalse();
            } else if (type == 'edit') {
                this.index = e.$index;
                this.row = JSON.parse(JSON.stringify(e.row));
                this.ruleForm.name = this.row.name;
                this.ruleForm.email = this.row.email;
                this.ruleForm.password = this.row.password;
                if (this.row.area_info.length != 0) {
                    let arr = [];
                    this.row.area_info.forEach((item, index) => {
                        // this.getpID1(index, item.province_id);
                        arr.push({
                            province_id: item.province_id,
                            city_id: item.province_name == item.city_name ? '' : item.city_id,
                            country_id: 227,
                            cityArr: [{'id':item.province_name == item.city_name ? '' : item.city_id,'name':item.city_name ,'province_id':item.province_id}]
                        });
                    });
                    console.log('arr :>> ', this.areaArr); 
                    this.areaArr = arr 
                }
            }
            this.showAdd = true;
        },
        getpID1(index, province_id) {
            let that = this;
            that.$get('/backapi/area', { province_id: province_id }).then(function (res1) {
                that.areaArr[index].cityArr = res1.data;
            });
        },
        // 删除
        getDel(e) {
            let that = this;
            that.$confirm('此操作将删除该员工, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let obj = {
                        id: e.row.id
                    };
                    that.$del('/backapi/user', obj).then(function (res) {
                        that.message.splice(e.$index, 1);
                        // that.$message({
                        //     type: 'success',
                        //     message: '删除成功!'
                        // });
                        that.msg = '删除成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    });
                })
                .catch(() => {
                    // that.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
        },
        // 重置密码
        getReset(e) {
            this.resetDialogVisible = true;
            this.row = e.row;
            this.index = e.$index;
        },
        resetDialogFalse() {
            this.row = {};
            this.resetDialogVisible = false;
            this.rowRemark.password = '';
        },
        resetDialogTrue() {
            let that = this;
            if (that.rowRemark.password == '') {
                that.$message({
                    type: 'warning',
                    message: '请输入新密码'
                });
                return;
            }
            let obj = {
                id: that.row.id,
                password: that.rowRemark.password
            };
            that.$put('/backapi/user', obj).then(function (res) {
                // that.$message({
                //     type: 'success',
                //     message: '修改成功!'
                // });
                that.msg = '修改成功';
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                that.resetDialogFalse();
            });
        },
        goBack() {
            this.resFalse();
        },
        // 添加省市
        getIncrease() {
            var obj = {
                province_id: '',
                city_id: '',
                country_id: 227,
                cityArr: []
            };
            this.areaArr.push(obj);
        },
        // 删除省市
        getDelete(i) {
            if (this.areaArr.length == 1) {
                this.$message({
                    type: 'info',
                    message: '不能删除了'
                });
                
            } else {
                this.areaArr.splice(i, 1);
            }
        },
        resFalse() {
            this.showAdd = false;
            this.ruleForm = {};
            this.row = {};
            this.index = -1;
            this.areaArr = [{ province_id: '', city_id: '', country_id: 227, cityArr: [] }];
        },
        // 取消操作
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.resFalse();
        },
        // 保存
        submitForm(formName) {
            let that = this;
            if (!that.ruleForm.name) {
                that.$message({
                    type: 'warning',
                    message: '请输入员工名称'
                });
                return;
            }
            if (!that.ruleForm.email) {
                that.$message({
                    type: 'warning',
                    message: '请输入邮箱(用于接收下载数据)'
                });
                return;
            }
            if(this.row.id){

            }else{
                if (!that.ruleForm.password) {
                that.$message({
                    type: 'warning',
                    message: '请输入初始密码'
                });
                return;
            }
            }
          
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    let area_info = [];
                    if (that.areaArr.length != 0 && that.areaArr[0].province_id) {
                        that.areaArr.map((item) => {
                            area_info.push({ country_id: item.country_id, city_id: item.city_id, province_id: item.province_id });
                        });
                    }
                    let obj = {
                        name: that.ruleForm.name,
                        email: that.ruleForm.email,
                        area_info: JSON.stringify(area_info)
                    };
                    if (that.row.id) {
                        obj.id = that.row.id;
                        that.$put('/backapi/user', obj).then(function (res) {
                            if (res.code == 200) {
                                // that.$message({
                                //     message: '修改成功',
                                //     type: 'success'
                                // });
                                that.msg = '修改成功';
                                that.notificationns = true;
                                setTimeout(() => {
                                    that.notificationns = false;
                                }, 3000);
                                that.resFalse();
                                that.getMessage();
                            } else {
                                that.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        obj.password = that.ruleForm.password;
                        that.$post('/backapi/user', obj).then(function (res) {
                            if (res.code == 200) {
                                // that.$message({
                                //     message: '添加成功',
                                //     type: 'success'
                                // });
                                that.msg = '添加成功';
                                that.notificationns = true;
                                setTimeout(() => {
                                    that.notificationns = false;
                                }, 3000);
                                that.resFalse();
                                that.getMessage();
                            } else {
                                that.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
/deep/.el-table .el-table__cell {
    border: none;
}
/deep/.areaArr .el-form-item .el-form-item__content {
    height: 111px !important;
    overflow: auto !important;
    padding: 10px 0;
}
.mr5 {
    margin-right: 10px;
}
.v_add {
    width: 25.61px;
    height: 25.58px;
}
.mb8 {
    margin-bottom: 8px;
}
.mb24 {
    margin-bottom: 24px;
}
.span {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    /* identical to box height, or 20px */

    color: #697077;
}
/deep/.el-form-item__label {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 14px;

    color: #21272a;
}
/deep/.v_doing .el-select__caret {
    color: #21272a;
    font-size: 20px;
    font-weight: 600;
}
/deep/.el-form-item {
    display: flex;
    flex-direction: column;
}
/deep/ .v_doing .el-dialog {
    background: #ffffff;
    border: 1px solid #dde1e6;
    border-radius: 16px;
    padding: 24px;
}
/deep/.v_doing .el-dialog .el-dialog__header {
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_doing .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_doing .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_doing .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_doing .el-dialog__body {
    padding: 0;
}
/deep/.v_doing .el-input__inner {
    height: 48px;
    padding: 13px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/*  */
/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}

.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

.mb8 {
    margin-bottom: 8px;
}
.mb24 {
    margin-bottom: 24px;
}
.mb16 {
    margin-bottom: 16px;
}
.headline_div {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}
.u_text {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
.textJustify {
    text-align: justify;
}

.demo-ruleForm {
    /* margin-left: 20px; */
}
.mt15 {
    margin-top: 15px;
}
.mr10 {
    margin-right: 10px;
}

/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
</style>
